import { render } from "./Plus.vue?vue&type=template&id=7fecc21f"
import script from "./Plus.vue?vue&type=script&lang=js"
export * from "./Plus.vue?vue&type=script&lang=js"
script.render = render

export default script